import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-view-terms-condition-popup',
  templateUrl: './view-terms-condition-popup.component.html',
  styleUrls: ['./view-terms-condition-popup.component.scss']
})
export class ViewTermsConditionPopupComponent implements OnInit {

  @Input('data') data: any;
  nodes:any[]=[];
  mainHeading;
  
  constructor(
    private modalController: ModalController
  ) {}
  ngOnInit(): void {
    this. mainHeading = this.data?.title;
    this.nodes = this.data?.description?.json;
    console.log(this.nodes);
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

}
